<app-card-base [title]="'Créer son compte EEMO'" [hasSubmit]="true" [submitText]="'Créer'" (onSubmitEvent)="onSubmit()"
  [loading]="loading" [isDisabled]="registerForm.invalid">
  <ng-container main *ngTemplateOutlet="register"></ng-container>
  <ng-container footer *ngTemplateOutlet="footer"></ng-container>
</app-card-base>

<ng-template #register>
  <form [formGroup]="registerForm" (ngSubmit)="onSubmit()">
    <div class="form-group">
      <input type="hidden" formControlName="role" />
      <h4>Vous êtes :</h4>
      <mat-radio-group formControlName="role" color="primary" required>
        <mat-radio-button class="col-md-6" value="INDIVIDUAL">Un particulier</mat-radio-button>
        <mat-radio-button class="col-md-6" value="REAL_ESTATE">Un agent immobilier</mat-radio-button>
        <mat-radio-button class="col-md-6" value="NOTARY">Un notaire</mat-radio-button>
        <mat-radio-button class="col-md-6" value="PROFESSIONAL">Un professionnel du bâtiment</mat-radio-button>
      </mat-radio-group>
    </div>
    <div class="form-group mt-2">
      <div class="row">
        <mat-form-field class="col-md-6">
          <mat-label>Votre prénom</mat-label>
          <input matInput required formControlName="firstName" placeholder="" />
          <mat-error>
            <span *ngIf="f('firstName').hasError('required')">Veuillez saisir votre prénom</span>
            <span *ngIf="f('firstName').hasError('maxlength')">50 caractères maximum</span>
            <span *ngIf="f('firstName').hasError('badUserName')">Certains caractères sont invalides</span>
          </mat-error>
        </mat-form-field>
        <mat-form-field class="col-md-6">
          <mat-label>Votre Nom</mat-label>
          <input matInput required formControlName="name" placeholder="" />
          <mat-error>
            <span *ngIf="f('name').hasError('required')">Veuillez saisir votre nom</span>
            <span *ngIf="f('name').hasError('maxlength')">50 caractères maximum</span>
            <span *ngIf="f('name').hasError('badUserName')">Certains caractères sont invalides</span>
          </mat-error>
        </mat-form-field>
      </div>
      <div class="row">
        <mat-form-field class="col-md-6">
          <mat-label>Votre adresse email</mat-label>
          <input matInput required type="email" formControlName="email" placeholder="" email autocomplete="username"
            name="username" id="username" />
          <mat-error *ngIf="f('email').hasError('required');">
            <span>Veuillez saisir votre adresse email</span>
          </mat-error>
          <mat-error *ngIf="f('email').hasError('email')">
            <span>Veuillez saisir une adresse email valide</span>
          </mat-error>
          <mat-error *ngIf="f('email').hasError('exists')">
            <span>Cette adresse email est déjà utilisée</span>
          </mat-error>
          <mat-error *ngIf="f('email').hasError('notManaged')">
            <span>Votre email est déjà pris en charge. Veuillez le renseigner
              sur la page de connexion.</span>
          </mat-error>
        </mat-form-field>
        <mat-form-field class="col-md-6">
          <mat-label>Téléphone</mat-label>
          <input matInput placeholder="" type="text" formControlName="phoneNumber" />
          <mat-error>
            <span *ngIf="f('phoneNumber').hasError('phoneNumber')">{{ 'error.phoneNumber' | translate }}</span>
          </mat-error>
        </mat-form-field>
      </div>
      <div class="row">
        <mat-form-field class="col-md-6">
          <mat-label>Votre mot de passe</mat-label>
          <input matInput required [type]="hidePassword ? 'password' : 'text'" formControlName="password" placeholder=""
            autocomplete="new-password" name="new-password" id="new-password" />
          <mat-icon matSuffix role="button"
            [appTooltip]="hidePassword ? 'Afficher le mot de passe' : 'Masquer le mot de passe'"
            (click)="hidePassword = !hidePassword">{{hidePassword ? 'visibility_off' : 'visibility'}}</mat-icon>
          <mat-error>
            <span *ngIf="f('password').hasError('required')">Veuillez saisir un mot de passe</span>
            <span *ngIf="f('password').hasError('passwordDontMatch')">Les mots de passe ne correspondent pas</span>
            <span *ngIf="f('password').hasError('pattern')">Mot de passe trop simpliste</span>
            <span *ngIf="f('password').hasError('refusedPassword')">Mot de passe non autorisé<mat-icon
                mdbPopover="Trop de caractères identiques consécutifs (maximum 3)" trigger="focus"
                tabindex="0">info</mat-icon></span>
          </mat-error>
        </mat-form-field>
        <mat-form-field class="col-md-6">
          <mat-label>Confirmer le mot de passe</mat-label>
          <input matInput required [type]="hidePasswordConfirm ? 'password' : 'text'"
            formControlName="passwordConfirmed" placeholder="" autocomplete="new-password" name="confirm-password"
            id="confirm-password" />
          <mat-icon matSuffix role="button"
            [appTooltip]="hidePasswordConfirm ? 'Afficher le mot de passe' : 'Masquer le mot de passe'"
            (click)="hidePasswordConfirm = !hidePasswordConfirm">{{hidePasswordConfirm ? 'visibility_off' :
            'visibility'}}</mat-icon>
          <mat-error *ngIf="f('passwordConfirmed').hasError('required')">
            <span>Veuillez confirmer le mot de passe</span>
          </mat-error>
        </mat-form-field>
        <app-password-check *ngIf="f('password').value" [passwordFormField]="form_password"></app-password-check>
        <div class="mt-2 col-md-12 text-center">
          <mat-checkbox formControlName="cgu">J'accepte les
            <span appTooltip="Consulter le document">
              <a *ngIf="!appConfigService.isMobileApp" [href]="cguUrl" target="_blank">conditions générales
                d'utilisation</a>
              <a *ngIf="appConfigService.isMobileApp" (click)="viewCguInGoogleDoc()">conditions générales
                d'utilisation</a></span>
          </mat-checkbox>
          <mat-error *ngIf="f('cgu').hasError('required'); else noCguError">
            <span><small>Les CGU doivent être
                acceptées</small></span>
          </mat-error>
          <ng-template #noCguError><span>&nbsp;</span></ng-template>
        </div>
      </div>
    </div>
  </form>
</ng-template>

<ng-template #footer>
  <div class="d-flex flex-row-reverse">
    <button mat-flat-button color="primary" routerLink="/login" [queryParams]="getBackLoginParams()">Retour</button>
  </div>
</ng-template>